import type { Creative } from './types';

const CREATIVE_EXPORT_COLUMNS = [
  'id',
  'name',
  'production_id',
  'channel',
  'status',
  'media_type',
  'format',
  'spec',
  'agency',
  'asset_count',
  'created_by',
  'created_at',
  'last_used_at',
] as const;

function csvCell(value: unknown): string {
  const text = value == null ? '' : String(value);
  return `"${text.replaceAll('"', '""')}"`;
}

export function creativesToCsv(creatives: Creative[]): string {
  const rows = creatives.map((creative) => [
    creative.id,
    creative.name,
    creative.production_id,
    creative.channel,
    creative.status,
    creative.media_type,
    creative.format,
    creative.spec,
    creative.agency,
    creative.assets.length,
    creative.created_by,
    creative.created_at,
    creative.last_used_at,
  ]);
  return [
    CREATIVE_EXPORT_COLUMNS.map(csvCell).join(','),
    ...rows.map((row) => row.map(csvCell).join(',')),
  ].join('\r\n');
}

export function downloadCreativeCsv(
  creatives: Creative[],
  filename = 'creatives.csv',
): void {
  const url = URL.createObjectURL(new Blob(
    [creativesToCsv(creatives)],
    { type: 'text/csv;charset=utf-8' },
  ));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
